import {injectable} from "inversify";
import {OptionType} from "@dropDesk/presentation/components/inputs/select_search_main/select_search";

@injectable()
export abstract class SegmentsRepository {
  public abstract getSegments(): Promise<Array<OptionType<string>>>;
}
